// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2Fg08","inputWrap":"styles_inputWrap__3_usK","input":"styles_input__1fKqs"};